import { EditTeamPanel } from './EditTeamPanel.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(EditTeamPanel)

export { withUnmountHoc as EditTeamPanel }
